import { render, staticRenderFns } from "./MyZs5.vue?vue&type=template&id=9b288b14&scoped=true&"
import script from "./MyZs5.vue?vue&type=script&lang=js&"
export * from "./MyZs5.vue?vue&type=script&lang=js&"
import style0 from "./MyZs5.vue?vue&type=style&index=0&id=9b288b14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b288b14",
  null
  
)

export default component.exports